import type { Store } from '@campaign/domain/store';
import { initializeAppAuthentication } from '@campaign/domain/middlewares/auth/utils';
import { setInitialized } from '@campaign/domain/store/reducers';

let scrollRestorationConfigured = false;

/**
 * Runs app-level initialization once and initializes auth
 * Skips if already initialized. Safe to call from render on each pass;
 * only the first call before `initialized` is true starts work
 */
export function runAppInitialization(store: Store): void {
  if (store.deref().initialized) return;

  if (!scrollRestorationConfigured && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
    scrollRestorationConfigured = true;
  }

  void initializeAppAuthentication(store);
  setInitialized(store);
}
